const IME_PLACEHOLDER_KEYS = new Set(['Process', 'Unidentified', 'Dead']);

const CODE_BY_KEY: Record<string, string> = {
  '/': 'Slash',
  a: 'KeyA',
  d: 'KeyD',
  f: 'KeyF',
  g: 'KeyG',
  h: 'KeyH',
  j: 'KeyJ',
  k: 'KeyK',
  l: 'KeyL',
  m: 'KeyM',
  n: 'KeyN',
  o: 'KeyO',
  u: 'KeyU',
  y: 'KeyY',
};

export function shortcutKeyMatches(
  event: Pick<KeyboardEvent, 'key' | 'code'>,
  key: string,
): boolean {
  if (event.key === key) return true;
  return IME_PLACEHOLDER_KEYS.has(event.key) && event.code === CODE_BY_KEY[key];
}

export type PublicStoryShortcutAction =
  | 'focus_next'
  | 'focus_previous'
  | 'toggle_details'
  | 'open_source';

export function publicStoryShortcutAction(
  event: Pick<KeyboardEvent, 'key' | 'code' | 'metaKey' | 'ctrlKey' | 'altKey'>,
  isTyping: boolean,
): PublicStoryShortcutAction | null {
  if (isTyping || event.metaKey || event.ctrlKey || event.altKey) return null;
  if (shortcutKeyMatches(event, 'j')) return 'focus_next';
  if (shortcutKeyMatches(event, 'k')) return 'focus_previous';
  if (shortcutKeyMatches(event, 'o')) return 'toggle_details';
  if (shortcutKeyMatches(event, 'l')) return 'open_source';
  if (event.key === 'Enter') return 'open_source';
  return null;
}
